var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserLoginController',{attrs:{"clientType":_vm.clientType,"context":_vm.context,"mfaType":_vm.mfaType,"paramError":_vm.error,"redirectTo":_vm.completeRedirectUrl,"step":_vm.step}})
}
var staticRenderFns = []

export { render, staticRenderFns }